﻿import type { AddTabToWorkspaceOptions } from 'epic/workspace/common/tabs/tabsEpics';
import { openTabInWorkspaceEpic } from 'epic/workspace/common/tabs/tabsEpics';
import type { SecondaryMarketLimitOrderReloadRequestedByOrderId } from 'state/secondaryMarket/limit-order/limitOrder.actions';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import type { EpicWithThunk } from 'state/state.common';
import type { WorkspacePersistedTabsApplied } from 'state/workspaces/workspace.actions';

export function secondaryWorkspaceReloadLimitOrderByOrderIdEpic(): EpicWithThunk {
  const opt: AddTabToWorkspaceOptions<
    SecondaryMarketLimitOrderReloadRequestedByOrderId,
    WorkspacePersistedTabsApplied
  > = {
    workspaceReadyTriggers: ['WORKSPACE_PERSISTED_TABS_APPLIED'],
    targetWorkspace: 'secondaryMarketQuotes',
    triggers: ['SECONDARY_MARKET_LIMIT_ORDER_RELOAD_REQUESTED_BY_ORDER_ID'],
    navigateRoute: { path: '/secondary-market-quotes-workspace' },
    onReady: ({ orderId }) => {
      return limitOrderThunks.tabCreatedByOderIdThunk(orderId);
    },
  };
  return openTabInWorkspaceEpic(opt);
}
